import {NgModule} from '@angular/core';

import {NavbarHorizontalStyle1Component} from './style-1.component';
import { CdkNavigationComponent } from '@cdk/components/navigation/navigation.component';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
    imports: [
    MatButtonModule,
    MatIconModule,
    CdkNavigationComponent,
    NavbarHorizontalStyle1Component
],
    exports: [
        NavbarHorizontalStyle1Component
    ]
})
export class NavbarHorizontalStyle1Module {
}
